export class PinchZoom {
  private element: HTMLElement;
  private container: HTMLElement;
  private initialScale: number = 1;
  private currentScale: number = 1;
  private lastDistance: number = 0;
  private isDragging: boolean = false;
  private startX: number = 0;
  private startY: number = 0;
  private translateX: number = 0;
  private translateY: number = 0;

  constructor(elementId: string, containerId: string) {
    this.element = document.getElementById(elementId) as HTMLElement;
    this.container = document.getElementById(containerId) as HTMLElement;
    this.initializeEvents();
  }

  private initializeEvents(): void {
    this.element.addEventListener(
      'touchstart',
      this.handleTouchStart.bind(this)
    );
    this.element.addEventListener('touchmove', this.handleTouchMove.bind(this));
    this.element.addEventListener('touchend', this.handleTouchEnd.bind(this));
  }

  private getDistance(touch1: Touch, touch2: Touch): number {
    const dx = touch1.clientX - touch2.clientX;
    const dy = touch1.clientY - touch2.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  private handleTouchStart(e: TouchEvent): void {
    if (e.touches.length === 2) {
      e.preventDefault();
      this.lastDistance = this.getDistance(e.touches[0], e.touches[1]);
    } else if (e.touches.length === 1 && this.currentScale > 1) {
      this.isDragging = true;
      this.startX = e.touches[0].clientX - this.translateX;
      this.startY = e.touches[0].clientY - this.translateY;
    }
  }

  private handleTouchMove(e: TouchEvent): void {
    if (e.touches.length === 2) {
      e.preventDefault();
      const distance = this.getDistance(e.touches[0], e.touches[1]);
      const scale = (distance / this.lastDistance) * this.currentScale;

      this.currentScale = Math.min(Math.max(scale, 1), 3);
      this.lastDistance = distance;

      this.updateTransform();
    } else if (
      e.touches.length === 1 &&
      this.isDragging &&
      this.currentScale > 1
    ) {
      const dx = e.touches[0].clientX - this.startX;
      const dy = e.touches[0].clientY - this.startY;

      // 移動制限の計算
      const maxX =
        (this.element.offsetWidth * this.currentScale -
          this.element.offsetWidth) /
        2;
      const maxY =
        (this.element.offsetHeight * this.currentScale -
          this.element.offsetHeight) /
        2;

      this.translateX = Math.min(Math.max(dx, -maxX), maxX);
      this.translateY = Math.min(Math.max(dy, -maxY), maxY);

      this.updateTransform();
    }
  }

  private handleTouchEnd(): void {
    this.isDragging = false;
    this.lastDistance = 0;

    // スケールが1に戻った場合、位置もリセット
    if (this.currentScale <= 1) {
      this.translateX = 0;
      this.translateY = 0;
      this.updateTransform();
    }
  }

  private updateTransform(): void {
    this.element.style.transform = `translate(${this.translateX}px, ${this.translateY}px) scale(${this.currentScale})`;
  }
}

// DOMContentLoadedイベントでインスタンス化
document.addEventListener('DOMContentLoaded', () => {
  new PinchZoom('zoomTarget', 'zoomContainer');
});
